import {IConfigIndividual} from './config.individual';
import {IToastIconClasses} from './toast-icon-classes';

/**
 * Global Toast configuration
 * Includes all IndividualConfig
 */
export interface IConfigGlobal extends IConfigIndividual {
  /**
   * max toasts opened. Toasts will be queued
   * Zero is unlimited
   * default: 0
   */
  maxOpened: number;
  /**
   * dismiss current toast when max is reached
   * default: false
   */
  autoDismiss: boolean;
  iconClasses: Partial<IToastIconClasses>;
  /**
   * block duplicate messages
   * default: false
   */
  preventDuplicates: boolean;
  /**
   * display the number of duplicate messages
   * default: false
   */
  countDuplicates: boolean;
  /**
   * Reset toast timeout when there's a duplicate (preventDuplicates needs to be set to true)
   * default: false
   */
  resetTimeoutOnDuplicate: boolean;
  /**
   * consider the title of a toast when checking if duplicate
   * default: false
   */
  includeTitleDuplicates: boolean;
}

export const DefaultNoComponentGlobalConfig: IConfigGlobal = {
  maxOpened: 0,
  autoDismiss: false,
  newestOnTop: true,
  preventDuplicates: false,
  countDuplicates: false,
  resetTimeoutOnDuplicate: false,
  includeTitleDuplicates: false,

  iconClasses: {
    // error: 'toast-error',
    // error: 'text-bg-danger',
    error: 'border-danger-subtle',
    // info: 'toast-info',
    // info: 'text-bg-info',
    info: 'border-info-subtle',
    // success: 'toast-success',
    // success: 'text-bg-success',
    success: 'border-success-subtle',
    // warning: 'toast-warning',
    // warning: 'text-bg-warning',
    warning: 'border-warning-subtle',
  },

  // Individual
  closeButton: false,
  disableTimeOut: false,
  timeOut: 5000,
  extendedTimeOut: 1000,
  enableHtml: false,
  progressBar: false,
  // toastClass: 'ngx-toastr',
  // toastClass: 'toast',
  // toastClass: 'toast fade show',
  toastClass: 'toast fade show d-block mb-2',
  // positionClass: 'toast-top-right',
  // positionClass: 'top-0 end-0 p-4',
  // positionClass: 'bottom-0 end-0 p-4',
  positionClass: 'position-fixed bottom-0 end-0 p-3',
  // titleClass: 'toast-title',
  titleClass: 'toast-title',
  // messageClass: 'toast-message',
  messageClass: 'toast-body',
  easing: 'ease-in',
  easeTime: 200,
  tapToDismiss: true,
  onActivateTick: false,
  progressAnimation: 'decreasing',
};
